export default __webpack_public_path__ + "static/media/settings.708e3cbc.svg";